import React, {ReactNode} from "react";
import DeviceLink from "../icons/DeviceLink";
import DevicePlaying from "../icons/DevicePlaying";
import DeviceScheduleClock from "../icons/DeviceScheduleClock";
import DeviceVolume from "../icons/DeviceVolume";
import {DeviceStatusIconsProps} from "./DeviceStatusIcons.types";


class DeviceStatusIcons extends React.Component<DeviceStatusIconsProps> {


    public render(): ReactNode {
        return (
            <div style={{
                display: "table",
                width: "fit-content",
                lineHeight: 0,
                ...(this.props.iconsFontSize ? {fontSize: this.props.iconsFontSize } : {}),
                ...this.props.style,
            }}>
                <div style={{
                    display: "table-cell",
                    padding: "0 0.25em",
                    textAlign: "center",
                    verticalAlign: "middle",
                }}>
                    <DeviceLink
                        device={this.props.device}
                        onlineExpressionI18N={this.props.onlineExpressionI18N}
                        style={this.props.iconsFontSize ? {fontSize: "1em"} : {}}
                    />
                </div>

                <div style={{
                    display: "table-cell",
                    padding: "0 0.25em",
                    textAlign: "center",
                    verticalAlign: "middle",
                }}>
                    <DeviceScheduleClock
                        device={this.props.device}
                        statusLocalTimeLabelI18N={this.props.statusLocalTimeLabelI18N}
                        style={this.props.iconsFontSize ? {fontSize: "1em"} : {}}
                    />
                </div>

                <div style={{
                    display: "table-cell",
                    padding: "0 0.25em",
                    textAlign: "center",
                    verticalAlign: "middle",
                }}>
                    <DevicePlaying
                        device={this.props.device}
                        activeResourceI18N={this.props.activeResourceI18N}
                        style={this.props.iconsFontSize ? {fontSize: "1em"} : {}}
                    />
                </div>

                <div style={{
                    display: "table-cell",
                    padding: "0 0.25em",
                    textAlign: "center",
                    verticalAlign: "middle",
                }}>
                    <DeviceVolume
                        device={this.props.device}
                        basicRemoteController={this.props.basicRemoteController}
                        style={this.props.iconsFontSize ? {fontSize: "1em"} : {}}
                    />
                </div>

                {this.props.extraWidget && (
                    <div style={{
                        display: "table-cell",
                        padding: "0 0.25em",
                        textAlign: "center",
                        verticalAlign: "middle",
                    }}>
                        {this.props.extraWidget}
                    </div>
                )}

            </div>
        );
    }

}


export default DeviceStatusIcons;
